<template>
	<div>
		<canvas ref="myChart"></canvas>
	</div>
</template>

<script>
import { Chart } from "chart.js"
import CsrAPI from "../api/csr/csr"
import LoadingState from "../consts/LoadingState"

export default {
	data() {
		return {
			scoreData: [],
			chart: null,
			data: {
				labels: ["Human Rights", "Labour", "Anti-Corruption", "Environment"],
				datasets: [
					{
						label: "",
						data: [0, 0, 0, 0],
						backgroundColor: "rgba( 30, 124, 131, 1)",
						borderColor: "rgb(54, 162, 235)",
						borderWidth: 0.5,
					},
					{
						label: "",
						data: [0, 0, 0, 0],
						backgroundColor: "#8a7dc0",
						borderColor: "rgb(75, 192, 192)",
						borderWidth: 0.5,
					},
					{
						label: "",
						data: [0, 0, 0, 0],
						backgroundColor: "#1e9a74",
						borderColor: "rgb(75, 192, 192)",
						borderWidth: 0.5,
					},
					{
						label: "",
						data: [0, 0, 0, 0],
						backgroundColor: "#325593",
						borderColor: "rgb(75, 192, 192)",
						borderWidth: 0.5,
					},
					{
						label: "",
						data: [0, 0, 0, 0],
						backgroundColor: "#e9891b",
						borderColor: "rgb(75, 192, 192)",
						borderWidth: 0.5,
					},
				],
			},
			options: {
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								stepSize: 10,
								max: 100,
								callback: function(value) {
									return value + "%"
								},
							},
						},
					],
				},
			},
		}
	},
	mounted() {
		this.initChart(), this.loadData()
	},
	methods: {
		initChart() {
			this.chart = new Chart(this.$refs.myChart, {
				type: "bar",
				data: this.data,
				options: this.options,
			})
		},
		loadData() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			CsrAPI.getCSRAssessmentsall()
				.then((result) => {
					result[0].forEach((item) => {
						const date = new Date(item.timestamp)
						const year = date.getFullYear()
						this.scoreData.push({
							year: year,
							score1: Math.round(item.score1),
							score2: Math.round(item.score2),
							score3: Math.round(item.score3),
							score4: Math.round(item.score4),
						})
					})
					this.logHighestYears()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		logHighestYears() {
			if (this.scoreData.length === 0) return

			// Sort the scoreData array by year in descending order
			const sortedData = this.scoreData.sort((a, b) => b.year - a.year)

			// Dynamically update the datasets based on the available data
			for (let i = 0; i < 5; i++) {
				const yearData = sortedData[i] || {
					year: "N/A",
					score1: 0,
					score2: 0,
					score3: 0,
					score4: 0,
				}

				this.data.datasets[4 - i].label = yearData.year.toString()
				this.data.datasets[4 - i].data = [
					Math.round(yearData.score1),
					Math.round(yearData.score2),
					Math.round(yearData.score3),
					Math.round(yearData.score4),
				]
			}

			this.chart.update()
		},
	},
}
</script>

<style scoped>
/* Add your custom styles here */
</style>
